export const DEFAULT_STYLE = 'light';

export const PREFIXES = {
  solid: 'fas',
  light: 'fal',
  regular: 'far',
  brands: 'fab',
};
